<template>
	<section
		ref="figureSection"
		class="figure"
	>
		<span
			ref="number"
			class="number"
			>0.0</span
		>
	</section>
</template>

<script>
export default defineNuxtComponent({
	name: "KeyFigure",
	mixins: [],

	props: {
		modelValue: {
			type: Number,
			required: true,
		},
	},

	data() {
		return {
			counted: false,
		};
	},

	methods: {
		countNumber() {
			const endNumber = this.modelValue;
			const start = 0;
			const numSteps = (endNumber > 100 ? 100 : endNumber) * 5;
			const stepTime = Math.abs(Math.floor(200 / numSteps));

			if (start === endNumber) return;

			let current = start;
			const element = this.$refs["number"];

			if (Number(element.innerHTML) !== endNumber) {
				const timer = setInterval(function () {
					current += 0.5;

					if (current >= endNumber) element.innerHTML = endNumber.toFixed(1);
					else {
						element.innerHTML = current.toFixed(1);
					}
					if (current >= endNumber) {
						clearInterval(timer);
					}
				}, stepTime);
			}
		},
		startCounting() {
			this.counted = true;
			this.countNumber();
		},
	},

	mounted() {
		this.startCounting();
	},

	watch: {
		modelValue() {
			this.startCounting();
		},
	},
});
</script>
